import tokenManager from "@/utils/tokenManager";
import { STORAGE_KEY } from "@/constant/export/storage";
import { clearAssistantStore } from "@/components/AIAssistant/utils/assistantStore";

/**
 * Local session teardown shared by every path that ends a session: the explicit
 * logout, and the forced re-login we fall into when the refresh token is dead.
 * Clears the legacy token, the assistant keys and storage, and broadcasts the
 * reset. Never throws.
 *
 * Deliberately a leaf module with no endpoint imports. It is called from both
 * `endpoints/userService` and `auth/authToken`, and the latter is imported by
 * `endpoints/config` -- living here keeps that from closing a cycle.
 *
 * Deliberately NOT `localStorage.clear()`: this origin also holds preferences
 * that are not session state, and a blanket wipe would silently reset them on
 * every expiry.
 */
export const clearLocalSession = async (): Promise<void> => {
  tokenManager.removeToken();
  localStorage.removeItem("messages");
  localStorage.removeItem("historyMetadata");
  localStorage.removeItem("sessionInitialized");
  localStorage.removeItem(STORAGE_KEY.AI_ASSISTANT_WS_CLIENT_ID);
  localStorage.removeItem(STORAGE_KEY.AI_ASSISTANT_CONVERSATION_ID);
  localStorage.removeItem(STORAGE_KEY.WS_CLIENT_ID);
  try {
    await clearAssistantStore();
  } catch (error) {
    console.warn("[AI Assistant] Failed to clear assistant storage", error);
  }
  try {
    window.dispatchEvent(new CustomEvent("assistant:session-reset"));
  } catch (error) {
    console.warn("[AI Assistant] Failed to broadcast logout reset", error);
  }
};
